/*
  Fuego & Fragancia — pestañas de los sets rituales.

  El primer panel ya viene marcado como activo desde Liquid, así que sin este
  archivo la sección sigue enseñando un set completo. Las pestañas suman; no
  sostienen nada.

  Se esconde con una clase y no con `hidden`: los paneles declaran `display` en
  su regla de clase, y una regla de clase le gana a `[hidden]`. Con `hidden` se
  marcaba el panel y seguía viéndose. Es el mismo tropiezo que ya documentamos
  en ff-gallery.js.
*/
(function () {
  if (!window.customElements || customElements.get('ff-bundle-tabs')) return;

  customElements.define(
    'ff-bundle-tabs',
    class FfBundleTabs extends HTMLElement {
      connectedCallback() {
        // Los botones viven fuera de este elemento (van dentro del contenedor
        // centrado, arriba), así que se buscan desde la sección.
        this.seccion = this.closest('.ff-bundle');
        if (!this.seccion) return;

        this.botones = Array.from(this.seccion.querySelectorAll('[data-ff-bundle-tab]'));
        this.paneles = Array.from(this.querySelectorAll('[data-ff-bundle-panel]'));
        if (this.botones.length < 2 || !this.paneles.length) return;

        this.botones.forEach((boton) => {
          boton.addEventListener('click', () => this.mostrar(boton.dataset.ffBundleTab));
        });
      }

      mostrar(id) {
        this.botones.forEach((boton) => {
          const activo = boton.dataset.ffBundleTab === id;
          boton.classList.toggle('is-active', activo);
          boton.setAttribute('aria-selected', activo ? 'true' : 'false');
        });

        this.paneles.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.ffBundlePanel === id);
        });
      }
    }
  );
})();
